import { LitElement, css, html } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
// import { resolveRouterPath } from '../router';
// import { isCurrentRouterPath } from '../router';

import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import '@shoelace-style/shoelace/dist/components/animation/animation.js';

import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';

registerIconLibrary('default', {
  resolver: name => `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/${name}.svg`
});

import { styles } from '../../public/assets/themes/dark';
import { resolveRouterPath } from '../router';

@customElement('app-footer')
export class AppFooter extends LitElement {
  @property({ type: String }) title = 'ScadaGo';

  @property({ type: Boolean}) enableBack: boolean = false;

  @property({ type: Boolean}) quieroProbarlo: boolean = false;

  @state() isDrawerOpen: boolean = false;

  static styles = [styles, css`

    .lg-showme {
      display: none;
    }
    .lg-hideme {
      display: block;
    }
    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) {
      .lg-showme {
        display: block !important;
      }
      .lg-hideme {
        display: none;
      }
    }

    sl-button.chatOnWhatsapp-button  {
      position: fixed; bottom: 70px; right: 90px;
    }
    sl-button.chatOnWhatsapp-button::part(base)  {
      border-radius: var(--sl-border-radius-large);
      background-color: #25D366;
      border-color: #25D366;
      color: #fff;
      font-size: var(--sl-font-size-x-large);
    }

    sl-button.chatOnWhatsapp-button::part(label)  {
      color: #fff;
      font-size: var(--sl-font-size-large);
    }

    .footer-nav {
      margin-bottom: 1rem;
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-around;
      flex-direction: row;
    }

    @media (max-width: 600px) {
      .footer-nav {
        flex-direction: column;
        align-content: left;
      }
    }

    .footer-nav ul {
      list-style-type: none;
      padding-left: 0px;
    }
    .footer-nav ul li {
      margin-bottom: 18px;
      list-style: none;
      line-height: 1.3;
    }
    .footer-nav ul li a {
      text-decoration: none;
      color: #fff;
      font-weight: 400;
      line-height: 1.35;
    }

    .footer-nav ul li a:hover {
      opacity: 0.9;
    }

    footer .footer-brand .brand-title {
      font-size: var(--sl-font-size-medium);
      font-weight: 400;
      font-family: 'staatliches', serif-sans;
      margin-right: 1rem;
    }
    footer .footer-brand .brand-title .brand-title-caps {
      font-size: var(--sl-font-size-large);;
    }

    footer .footer-brand {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    footer .footer-brand .brand-logo {
      margin-right: 0.5 rem;
    }

  `];

  render() {
    return html`
    <footer>
      ${this.quieroProbarlo ? html`<app-quiero_probarlo></app-quiero_probarlo>` : null}

      <app-section variant="single-content" color="estiloFooter">
        <div class="footer-nav">
          <div>
            <h3>Empresa</h3>
            <ul>
              <li><a href="${resolveRouterPath('nosotros')}">Nosotros</a></li>
              <li><a href="download/politica-sgi" target="_blank">Política del Sistema de Gestión Integrado (SGI)</a></li>
              <li><a href="${resolveRouterPath('contactanos')}">Contactanos</a></li>
            </ul>
          </div>
          <div>
            <h3>Soluciones</h3>
            <ul>
              <li><a href="${resolveRouterPath('mobile')}">Aplicación mobile</a></li>
              <li><a href="${resolveRouterPath('pwa')}">Acceso web [PWA]</a></li>
            </ul>
          </div>
        </div>
      </app-section>
      <app-section variant="single-content" color="estiloFooter">
        <div class="footer-brand">
          <img src="/assets/icons/72x72.png" width="24" height="24" class="brand-logo" alt="ScadaGo Logo">
          <span class="brand-title"><span class="brand-title-caps">S</span>cada<span class="brand-title-caps">G</span>o</span> © 2026 ScadaGO. All rights reserved.
        </div>
      </app-section>


      <sl-animation name="bounceInRight" easing="ease-in-out" iterations="1" duration="1500" play>
        <sl-button
          class="chatOnWhatsapp-button"
          href="https://api.whatsapp.com/send/?phone=543414540500&amp;text=Quiero+probar+ScadaGo!%0D%0AMi+nombre+es...&amp;type=phone_number&amp;app_absent=0"
          target="_blank"
          size="large">
          <sl-icon slot="prefix" name="whatsapp"></sl-icon>
          Chatea en WhatsApp
        </sl-button>
      </sl-animation>
    </footer>


    `;
  }
}


